import { render } from "./ModalMeasurements.vue?vue&type=template&id=4573ca60"
import script from "./ModalMeasurements.vue?vue&type=script&lang=js"
export * from "./ModalMeasurements.vue?vue&type=script&lang=js"

import "./ModalMeasurements.vue?vue&type=style&index=0&id=4573ca60&lang=css"
script.render = render

export default script